import { render } from "./AddmanagerView.vue?vue&type=template&id=7369aa9a"
import script from "./AddmanagerView.vue?vue&type=script&lang=js"
export * from "./AddmanagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__